/* eslint-disable no-nested-ternary */
import { Box } from 'native-base';
import React, { useEffect, useState } from 'react';
import { AppState, Platform, View as RNView } from 'react-native';
import WebView from 'react-native-webview';

export type WebVideoProps = {
  url: string;
};

// see https://stackoverflow.com/a/45512877
export default function WebVideo({ url }: WebVideoProps) {
  const [appActive, setAppActive] = useState(true);

  useEffect(() => {
    const handler = (state: string) => setAppActive(state === 'active');
    const subscription = AppState.addEventListener('change', handler);
    return () => subscription.remove();
  }, []);

  return (
    <Box bgColor="gray.100" style={{ aspectRatio: 16 / 9 }} testID="URIVideo" width="full">
      {Platform.OS === 'web' ? (
        <div style={{ width: '100%', height: '100%' }}>
          <iframe src={url} style={{ border: 0, width: '100%', height: '100%' }} title="Video" />
        </div>
      ) : appActive ? (
        <RNView
          // IMPORTANT: without this the app will crash on Android whenever a parent attempts to unmount
          // see https://github.com/react-native-webview/react-native-webview/issues/811#issuecomment-748611465
          renderToHardwareTextureAndroid
          style={{ width: '100%', height: '100%' }}
        >
          <WebView
            javaScriptEnabled
            source={{ uri: url }}
            style={{ width: '100%', height: '100%', borderWidth: 0, opacity: 0.99 }}
          />
        </RNView>
      ) : (
        <Box />
      )}
    </Box>
  );
}
